<!-- http://localhost:7777/notice?notice_id=105790569 -->

<template>
    <section class="mobile_wrap">
        <hr class="notice__bar"/>
        <div class="notice__header">
          <p
            class="notice__title"
            v-html="notice.title"
          />
          <span 
            class="notice__regdt"
            v-html="notice.reg_date"
          />
        </div>
        <div
          class="notice__content"
          v-html="notice.content"
        />
        <loading v-show="loading"/>
        
    </section>
</template>

<script>
    import client from '../client/client'
    import Loading from '../components/Loading'
    import { useRoute } from 'vue-router'

    export default {
        name: "Notice",
        components: {
            Loading,
        },
        data: function () {
            const route = useRoute()
            const { query } = route;
            return {
                loading: false,
                success: false,
                query : query,
                notice : [],
            }
        },
        methods: {
            async update() {
                const route = useRoute()
                const { query } = route;
                let notice = await client.get(`/api/notice/${query.notice_id}`)
                let date = new Date(notice.result.reg_date);
                const year = date.getFullYear();
                let month = (1 + date.getMonth());
                month = month >= 10 ? month : `0${month}`;
                let day = date.getDate();
                day = day >= 10 ? day : `0${day}`;
                let hour = date.getHours();
                hour = hour >= 10 ? hour : `0${hour}`;
                let minutes = date.getMinutes();
                minutes = minutes >= 10 ? minutes : `0${minutes}`;

                this.notice = notice.result;
                this.notice.reg_date = `${year}-${month}-${day} ${hour}:${minutes}`
            },
        },
        async mounted() {
            this.update();
        },
    }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/icon.scss";
  .notice__bar{
    background:#f4f4f4;
    width:100%;
    height:10px;
    border:0;
    margin:0;
  }
  .mobile_wrap{
    max-width:640px;
    width:100%;
    margin:0 auto;
    background:#fff;
    box-shadow:0px 1px 10px rgba(0,0,0,0.1);
    display:flex;
    flex-direction:column;
    min-height:calc(100vh - 33px);
    /* min-height: 100vh; */
  }
  .notice__header{
    padding:16px 20px;
    border-bottom:1px solid #f4f4f4;
    .notice__title{
      line-height:20px;
      font-weight: 600;
      margin:0;
    }
    .notice__regdt{
      color:#848484;
      margin-top:12px;
      font-size:12px;
    }
  }
  .notice__content{
    padding: 20px;
    line-height: 2;
    word-break: break-all;
    color:#333;
    font-size:14px;
  }
</style>
